/**
 * Tag champs name for filters
 */
type TagFilterType =
  | 'NAME'
  | 'CONNECTION_NAME'
  | 'UNIT'
  | 'LOW_THRESHOLD'
  | 'HIGH_THRESHOLD'
  | 'LAST_DATETIME'
  | 'LAST_VALUE_TAG'
  | 'VALUE_TYPE'
  | 'GROUP'
  | 'ACTION';
const TagFilterType = (() => {
  const NAME: TagFilterType = 'NAME';
  const CONNECTION_NAME: TagFilterType = 'CONNECTION_NAME';
  const UNIT: TagFilterType = 'UNIT';
  const LOW_THRESHOLD: TagFilterType = 'LOW_THRESHOLD';
  const HIGH_THRESHOLD: TagFilterType = 'HIGH_THRESHOLD';
  const LAST_DATETIME: TagFilterType = 'LAST_DATETIME';
  const LAST_VALUE_TAG: TagFilterType = 'LAST_VALUE_TAG';
  const VALUE_TYPE: TagFilterType = 'VALUE_TYPE';
  const GROUP: TagFilterType = 'GROUP';
  const ACTION: TagFilterType = 'ACTION';

  function values(): TagFilterType[] {
    return [
      NAME,
      CONNECTION_NAME,
      UNIT,
      LOW_THRESHOLD,
      HIGH_THRESHOLD,
      LAST_DATETIME,
      LAST_VALUE_TAG,
      VALUE_TYPE,
      GROUP,
      ACTION
    ];
  }
  return { NAME, CONNECTION_NAME, UNIT, LOW_THRESHOLD, HIGH_THRESHOLD, LAST_DATETIME, LAST_VALUE_TAG, VALUE_TYPE, GROUP, ACTION, values };
})();

export { TagFilterType };
